/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownToBracket: {
  name: 'arrow-down-to-bracket';
  data: string;
} = {
  name: 'arrow-down-to-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="m15.707 12.707-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 12.586V5a1 1 0 1 1 2 0v7.586l1.293-1.293a1 1 0 0 1 1.414 1.414ZM6 17a1 1 0 1 0-2 0v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a1 1 0 1 0-2 0v1H6v-1Z" fill="currentColor"/></svg>`,
};
